import type { Work } from './api';
import { calculationGuide } from './calculationGuide';

export function CalculationGuide({work}: {work: Work}) {
  const text = calculationGuide(work);
  if (!text) return null;
  return <section className="calculation-guide" aria-label="Предварительный расчёт">
    <h3>Предварительный расчёт · итог уточнить</h3>
    <p>Рассчитанная часть и условия:</p>
    <p className="calculation-guide-basis">{text}</p>
    <p className="muted">Контрольное число, объём до вычетов и коэффициент не являются полным объёмом работы. Неизвестные границы, вычеты и дополнительные части уточняются по указанным основаниям.</p>
  </section>;
}
